import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import Light from 'components/headers/light';
import axios from 'axios';
import Swal from 'sweetalert2';
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import { useNavigate } from 'react-router-dom';  // Import useNavigate
import LightBuyer from 'components/headers/lightBuyer';
import AnnouncementBanner from 'components/AnnouncementBanner';

const Profile = () => {
  const [userInfo, setUserInfo] = useState({
    name: '',
    address: '',
    email: '',
    phone: ''
  });
  const [role, setRole] = useState('');

  const [formData, setFormData] = useState(userInfo);
  const token = localStorage.getItem('authToken');
  const user = JSON.parse(localStorage.getItem('user'));
  const navigate = useNavigate();  // Use navigate hook for redirection

  useEffect(() => {
    // Check if the user is logged in (authToken must exist)
    if (!token) {
      Swal.fire('Erreur', 'Vous devez être connecté pour accéder à votre profil.', 'error');
      navigate('/login');  // Redirect to login page if not authenticated
      return;
    }

    fetchAllUserInfo();
    const userRole = localStorage.getItem('role');
    setRole(userRole); // Set the role state based on what’s stored
  }, [token, navigate]);  // Re-run when token changes

  useEffect(() => {
    setFormData(userInfo);
  }, [userInfo]);

  const fetchAllUserInfo = async () => {
    try {
      const userId = user?.id;
      if (!token || !userId) return;

      const response = await axios.get(`https://hbmdijital.online/api/suppliers/${userId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (response.status === 200) {
        setUserInfo(response.data);

      }
    } catch (error) {
      console.error('Error fetching user info:', error);
    }
  };

  const handleInputChange = (e) => {
    const { id, value } = e.target;
    setFormData({ ...formData, [id]: value });
  };

  const handleSaveChanges = async () => {
    try {
      if (!token) return;

      const response = await axios.put(
        'https://hbmdijital.online/api/user/update',
        formData,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      if (response.status === 200) {
        Swal.fire({
          icon: 'success',
          title: 'Mise à jour réussie',
          text: 'Vos informations ont été mises à jour avec succès!',
          confirmButtonText: 'OK'
        }).then(() => {
          // Clear localStorage and redirect to the login page
          localStorage.removeItem('authToken');
          localStorage.removeItem('user');
          navigate('/login');  // Redirect to the login page
        });
      }
    } catch (error) {
      console.error('Error updating user info:', error);
    }
  };
  return (
    <AnimationRevealPage>
      {/* Conditionally render Light or LightBuyer based on user role */}
      {role === 'supplier' ? <Light /> : <LightBuyer />}
            <AnnouncementBanner />

      <div className="d-flex justify-content-center align-items-center vh-100">
        <div className="container w-100 w-md-75 p-3"> {/* Increased width and added padding */}
          <div className="card shadow-lg"> {/* Added shadow for a better visual on mobile */}
            <div className="card-header text-center fs-4">Détails du compte</div>
            <div className="card-body">
              <form>
                <div className="mb-3">
                  <label className="small mb-1" htmlFor="name">Nom Complet</label>
                 <input 
  className="form-control form-control-lg" 
  id="name" 
  type="text" 
  value={formData.name} 
  onChange={handleInputChange} 
  placeholder="Votre nom complet" 
  style={{ backgroundColor: '#f1f1f1', borderRadius: '10px', padding: '10px' }}
  disabled // This will disable the input
/>
                </div>

      {role === 'supplier' && (
  <div className="mb-3">
    <label className="small mb-1" htmlFor="grade">Grade</label>
    <input 
      className="form-control form-control-lg"
      id="grade" 
      type="text" 
      value={formData.grade} 
      disabled
    />
  </div>
)}

                <div className="mb-3">
                  <label className="small mb-1" htmlFor="email">Adresse email</label>
                  <input 
                    className="form-control form-control-lg" 
                    id="email" 
                    type="email" 
                    value={formData.email} 
                    onChange={handleInputChange} 
                    placeholder="Votre adresse email" 
                  />
                </div>
                <div className="row gx-3 mb-3">
                  <div className="col-12 col-md-6">
                    <label className="small mb-1" htmlFor="phone">Numéro de téléphone</label>
                    <input 
                      className="form-control form-control-lg" 
                      id="phone" 
                      type="tel" 
                      value={formData.phone} 
                      onChange={handleInputChange} 
                      placeholder="Votre numéro de téléphone" 
                    />
                  </div>
                  <div className="col-12 col-md-6">
                    <label className="small mb-1" htmlFor="address">Adresse</label>
                    <input 
                      className="form-control form-control-lg" 
                      id="address" 
                      type="text" 
                      value={formData.address} 
                      onChange={handleInputChange} 
                      placeholder="Votre adresse" 
                    />
                  </div>
                </div>
                <button 
    className="btn btn-lg w-100" 
    style={{ backgroundColor: '#1e3d56', color: 'white', border: 'none' }}
    type="button" 
    onClick={handleSaveChanges}
>
Sauvegarder
</button>

              </form>
            </div>
          </div>
        </div>
      </div>
    </AnimationRevealPage>
  );
};

export default Profile;
